/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Cue_Gave_UpInputs */

const en_us2_body_assessment_cue_gave_up = /** @type {(inputs: Body_Assessment_Cue_Gave_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That didn't work. Come back to the phone.`)
};

const pt_br2_body_assessment_cue_gave_up = /** @type {(inputs: Body_Assessment_Cue_Gave_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu certo. Volte ao celular.`)
};

const es_419_body_assessment_cue_gave_up = /** @type {(inputs: Body_Assessment_Cue_Gave_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No funcionó. Vuelve al teléfono.`)
};

const pt_pt2_body_assessment_cue_gave_up = /** @type {(inputs: Body_Assessment_Cue_Gave_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não resultou. Volta ao telemóvel.`)
};

const fr_fr2_body_assessment_cue_gave_up = /** @type {(inputs: Body_Assessment_Cue_Gave_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ça n'a pas marché. Reviens au téléphone.`)
};

const de_de2_body_assessment_cue_gave_up = /** @type {(inputs: Body_Assessment_Cue_Gave_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das hat nicht geklappt. Komm zurück zum Handy.`)
};

const it_it2_body_assessment_cue_gave_up = /** @type {(inputs: Body_Assessment_Cue_Gave_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non ha funzionato. Torna al telefono.`)
};

/**
* | output |
* | --- |
* | "That didn't work. Come back to the phone." |
*
* @param {Body_Assessment_Cue_Gave_UpInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_cue_gave_up = /** @type {((inputs?: Body_Assessment_Cue_Gave_UpInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Cue_Gave_UpInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_cue_gave_up(inputs)
	if (locale === "es-419") return es_419_body_assessment_cue_gave_up(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_cue_gave_up(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_cue_gave_up(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_cue_gave_up(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_cue_gave_up(inputs)
	return en_us2_body_assessment_cue_gave_up(inputs)
});
export { body_assessment_cue_gave_up as "body-assessment.cue.gave_up" }